import React from 'react'
import { GiSoccerField as Kvartersfotboll } from 'react-icons/gi'
import { FaChild as Parafotboll } from 'react-icons/fa'
import { GiSoccerBall as Nattfotboll } from 'react-icons/gi'
import { GiPoliceOfficerHead as Maxi } from 'react-icons/gi'
import { GiSoccerKick as Arenafotboll } from 'react-icons/gi'
import Turnering from '../assets/icons/tournament.png'
import Futsal from '../assets/icons/futsal.png'
import { IoGameController as Esports } from 'react-icons/io5'
import { CgGym as Tjejtraning } from 'react-icons/cg'

// instead of interface, do it inline
export function ActivityType({ type }: { type: string }) {
  const components = {
    Kvartersfotboll: <Kvartersfotboll />,
    Nattfotboll: <Nattfotboll />,
    Parafotboll: <Parafotboll />,
    Esports: <Esports />,
    Maxi: <Maxi />,
    Tjejträning: <Tjejtraning />,
    Arenafotboll: <Arenafotboll />,
    'Alblebish e-Trophy': <Esports />,
    'Alblebish Trophy': <img style={{ filter: 'invert(1)' }} src={Turnering} />,
    Turnering: <img style={{ filter: 'invert(1)' }} src={Turnering} />,
    Futsal: <img src={Futsal} />,
  }
  //@ts-ignore
  return components[type] || null
}
